import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';

const BlueGreen = ({ children, type, size, ...props })=>{
    return jsxs("svg", {
        height: size,
        width: size,
        ...props,
        children: [
            jsxs("linearGradient", {
                id: "icon-gradient-blue-green",
                children: [
                    jsx("stop", {
                        offset: "0%",
                        stopColor: "#68D7FA"
                    }),
                    jsx("stop", {
                        offset: "100%",
                        stopColor: "#7EF1B3"
                    })
                ]
            }),
            /*#__PURE__*/ React__default.isValidElement(children) && /*#__PURE__*/ React__default.cloneElement(children, {
                [type]: 'url(#icon-gradient-blue-green)'
            })
        ]
    });
};

export { BlueGreen };
//# sourceMappingURL=BlueGreen.es.js.map
